import axios from 'axios';
import {
  rootGizmoConfigV2ToV3,
  rootGizmoDataV2ToV3,
  rootGizmoDataV3ToV2,
} from '../../gizmos/utils';
import { IGizmoEvent } from '../../types';
import { Gizmo, RootGizmo } from '../../gizmos';
import clone from 'clone';

interface IParams {
  gizmo: Gizmo;
  rootGizmoData: any;
  context: {
    apiUrl: string;
    user?: any;
  };
}

/**
 * Run a script on the server
 *
 * @param {IGizmo} config Gizmo's configuration
 * @param {IRootGizmoData} rootGizmoData RootGizmoData we're going to validate on the server
 * @returns
 */
async function serverScript({
  gizmo,
  rootGizmoData,
  context,
}: IParams): Promise<any> {
  const { apiUrl, user } = context;
  const config = gizmo.getConfig();
  console.log('ssssssssss.script.config: ', config);
  const url = `${apiUrl}/main_api/v1/root_gizmo/data/server_validation`;
  let headers = {};
  // Before sending to the server we're going to convert the rootGizmoData to v2
  const register = rootGizmoDataV3ToV2({ data: rootGizmoData });

  if (user?.credentials) {
    headers = {
      ...user.credentials,
    };
  }
  const gizmoConfig = clone(config);
  if (gizmoConfig.ops?.serverValidation) {
    delete gizmoConfig.ops.serverValidation;
  }

  const create = gizmo.getCallbacks().getInfoCB({
    type: 'rootGizmoDataCreate',
  });
  if (create === false) {
    // Only when the root gizmo data is being created we're going to run the server script
    return undefined;
  }

  try {
    console.log('ssssssssss.script.url: ', url);
    console.log('g.config: ', gizmoConfig);
    const response = await axios({
      method: 'POST',
      url,
      data: {
        gizmo_uid: config.uid,
        gizmo_config: gizmoConfig,
        register,
      },
      headers,
    });

    if (response.status === 200) {
      const { data } = response;
      let registerExists = 0;

      if (
        data?.result &&
        typeof data.result === 'object' &&
        data.result.register &&
        data.result.form &&
        config.ops?.serverScript?.registerResult?.destinies
      ) {
        const { form, register: r } = data.result;
        const register = rootGizmoDataV2ToV3({ data: r });
        const destinies = config.ops.serverScript.registerResult.destinies;
        const rootGizmoConfig = rootGizmoConfigV2ToV3({ config: form });

        for (const destiny of destinies) {
          let originFid = destiny.originFid;
          if (
            !originFid &&
            destiny.originUid &&
            form.questions &&
            Array.isArray(form.questions)
          ) {
            const question = form.questions.find(
              (q: any) => q.uid === destiny.originUid
            );

            if (question) {
              originFid = question.f_id;
            }
          }

          if (originFid && register.d) {
            const data = register.d[originFid];

            if (data !== undefined) {
              const event: IGizmoEvent = {
                type: 'gizmo.set-data',
                src: {
                  type: 'gizmo',
                  gizmoFid: config.fid,
                  gizmoUid: config.uid,
                },
                dest: {
                  type: 'gizmo',
                  gizmoFid: destiny.destinyFid,
                  gizmoUid: destiny.destinyUid,
                },
                data: {
                  gizmoSetData: {
                    data,
                    rootGizmoConfig,
                    rootGizmoData: register,
                    destiny,
                  },
                },
              };

              gizmo.getEvents().next(event);
            }
          }
        }

        registerExists = 4;
      }

      if (
        data?.result &&
        typeof data.result === 'object' &&
        data.result.forms &&
        Array.isArray(data.result.forms) &&
        data.result.registers &&
        Array.isArray(data.result.registers) &&
        config.ops?.serverScript?.registerResult?.destinies
      ) {
        const rootGizmo: RootGizmo = gizmo.getCallbacks().getInfoCB({
          type: 'rootGizmo',
        });
        if (rootGizmo) {
          const gizmoFids = rootGizmo
            .findGizmos({
              type: 'annex_form',
            })
            .map(g => g.getConfig().fid);
          const forms = data.result.forms;
          const form = forms[0];
          const registers = data.result.registers;
          const r = registers[0];
          const register = rootGizmoDataV2ToV3({ data: r });
          const destinies = config.ops.serverScript.registerResult.destinies;
          const rootGizmoConfig = rootGizmoConfigV2ToV3({ config: form });

          for (const destiny of destinies) {
            let originFid = destiny.originFid;
            if (
              !originFid &&
              destiny.originUid &&
              form.questions &&
              Array.isArray(form.questions)
            ) {
              const question = form.questions.find(
                (q: any) => q.uid === destiny.originUid
              );

              if (question) {
                originFid = question.f_id;
              }
            }

            if (originFid && register.d) {
              const data = register.d[originFid];

              let isAnnexForm = false;
              if (destiny.destinyFid) {
                isAnnexForm = gizmoFids.includes(destiny.destinyFid);
              }

              if (data !== undefined) {
                if (!isAnnexForm) {
                  const event: IGizmoEvent = {
                    type: 'gizmo.set-data',
                    src: {
                      type: 'gizmo',
                      gizmoFid: config.fid,
                      gizmoUid: config.uid,
                    },
                    dest: {
                      type: 'gizmo',
                      gizmoFid: destiny.destinyFid,
                      gizmoUid: destiny.destinyUid,
                    },
                    data: {
                      gizmoSetData: {
                        data,
                        rootGizmoConfig,
                        rootGizmoData: register,
                        destiny,
                      },
                    },
                  };

                  gizmo.getEvents().next(event);
                } else {
                  const event: IGizmoEvent = {
                    type: 'gizmo.set-data',
                    src: {
                      type: 'gizmo',
                      gizmoFid: config.fid,
                      gizmoUid: config.uid,
                    },
                    dest: {
                      type: 'gizmo',
                      gizmoFid: destiny.destinyFid,
                      gizmoUid: destiny.destinyUid,
                    },
                    data: {
                      gizmoSetData: {
                        data,
                        rootGizmoConfigList: forms.map((f: any) =>
                          rootGizmoConfigV2ToV3({ config: f })
                        ),
                        rootGizmoDataList: registers.map((r: any) =>
                          rootGizmoDataV2ToV3({ data: r })
                        ),
                        formList: forms,
                        filledFormList: registers,
                        destiny,
                      },
                    },
                  };

                  gizmo.getEvents().next(event);
                }
              }
            }
          }
        }
      }

      if (
        config.ops?.serverScript?.registerResult?.existsUid ||
        config.ops?.serverScript?.registerResult?.existsFid
      ) {
        const event: IGizmoEvent = {
          type: 'gizmo.set-data',
          src: {
            type: 'gizmo',
            gizmoFid: config.fid,
            gizmoUid: config.uid,
          },
          dest: {
            type: 'gizmo',
            gizmoFid: config.ops.serverScript.registerResult.existsFid,
            gizmoUid: config.ops.serverScript.registerResult.existsUid,
          },
          data: {
            gizmoSetData: {
              data: { v: registerExists },
            },
          },
        };

        gizmo.getEvents().next(event);
      }
    }
  } catch (e) {
    console.log('server-script.error: ', e);
  }

  return undefined;
}

export default serverScript;
